<template>
  <div>
    <liff-error-modal
        ref="errorModal"
        @ok-submit="closeWindow"
        :head="formErrorMsg.head"
        :isWarning="formErrorMsg.isWarning"
        :msg="formErrorMsg.message"/>

    <liff-success-modal
        ref="liffSuccessModal"
        @ok-submit="closeWindow"
        :msg="successMsg"
        :textBtn="this.$vuetify.lang.t('$vuetify.checkInOnsite.confirm')"/>

    <check-in-by-location
        ref="checkInByLocation"
        @submit="submit"
        @errorModal="errorModal"
        @close="closeWindow"
        :lineId="lineId"
        :header="this.$vuetify.lang.t('$vuetify.checkInOnsite.checkinOnsite')"/>
  </div>
</template>

<script>
import LiffErrorModal from '@/components/modal/LiffErrorModal'
import LiffSuccessModal from '@/components/modal/LiffSuccessModal'
import CheckInByLocation from '@/components/Liff/CheckInByLocation'
import axios from 'axios'
export default {
    name: 'CheckinOnSite',

    components: {
        LiffErrorModal,
        LiffSuccessModal,
        CheckInByLocation
    },

    data () {
        return {
            mode: 'view',
            successMsg: null,
            lineId: null,
            formErrorMsg: {
                head: '',
                isWarning: false,
                msg: ''
            },
            textareaRule: [
                v => !!v || this.$vuetify.lang.t('$vuetify.checkInOnsite.fieldRequired')
            ]
        }
    },

    methods: {
        async getOnsiteInquiry () {
            const res = await axios.post(`${process.env.VUE_APP_BACKEND}/attendance-today`, { lineId: this.lineId })
            this.inquiry = res.data.status
            if (res && res.data && res.data.status === 'ok') {
                try {
                    this.$refs.checkInByLocation.getLocation()
                } catch (e) {
                    this.errorModal(
                        this.$vuetify.lang.t('$vuetify.checkInOnsite.sorryUnablerocess'),
                        this.$vuetify.lang.t('$vuetify.checkInOnsite.getLocationError')
                    )
                }
            } else {
                this.formErrorMsg.isWarning = true
                this.errorModal(this.$vuetify.lang.t('$vuetify.checkInOnsite.attendanceDetails'), res.data.msg)
            }
        },

        errorModal (head, message) {
            this.$store.dispatch('setLoading', false)
            this.formErrorMsg.head = head
            this.formErrorMsg.message = message
            this.$refs.errorModal.dialog = true
        },

        async submit (submitForm) {
            this.$store.dispatch('setLoading', true)
            const res = await axios.post(`${process.env.VUE_APP_BACKEND}/attendance-onsite/location/create`, submitForm)
            if (res && res.data && res.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)
                this.successMsg = res.data.msg
                this.$refs.liffSuccessModal.dialog = true
            } else {
                this.errorModal(this.$vuetify.lang.t('$vuetify.checkInOnsite.success'), res.data.msg)
            }
        },

        async closeWindow () {
            await this.$liffUtil.closeWindow(process.env.VUE_APP_LINE_LOCATION_LIFF)
        }
    },

    async mounted () {
        this.$store.dispatch('setLoading', true)
        try {
            this.lineId = await this.$liffUtil.getLineIdForLiff(process.env.VUE_APP_LINE_LOCATION_LIFF)
            await this.getOnsiteInquiry()
        } catch (error) {
            this.errorModal(this.$vuetify.lang.t('$vuetify.checkInOnsite.sorryUnablerocess'), this.$vuetify.lang.t('$vuetify.checkInOnsite.getLocationError'))
        }
        this.$store.dispatch('setLoading', false)
    }
}
</script>

<style>

</style>
